import { Routes } from "@angular/router";
import { NotesPageComponent } from "./notes-page.component";
import { authGuard } from "../../../core/guards/auth.guard";

export const notesPageRoutes: Routes = [
  {
    path: 'records/notes',
    component: NotesPageComponent,
    canActivate: [authGuard]
  }
]
